import { connect } from 'react-redux';
import { UsersListFilters } from './UsersListFilters';
import { getFilters } from 'src/redux/users/usersSelectors';
import { getI18n } from 'src/redux/core/coreSelectors';
import { usersActions } from 'src/redux/users/usersActions';
var mapStateToProps = function (state) { return ({
    filters: getFilters(state),
    i18n: getI18n(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    updateFilters: function (newFilters) { return dispatch(usersActions.updateUsersFilterRequested(newFilters)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(UsersListFilters);
